var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63659 2H29.8222C30.7261 2 31.4588 2.7326 31.4588 3.63638L31.4591 6.23172C31.4593 6.66587 31.2868 7.08224 30.9798 7.38921L20.4819 17.8866C20.175 18.1934 20.0025 18.6098 20.0025 19.0438V29.3625C20.0025 30.4273 19.0019 31.2086 17.969 30.9503L14.6958 30.132C13.9672 29.9499 13.4561 29.2952 13.4561 28.5442V19.0438C13.4561 18.6098 13.2837 18.1934 12.9768 17.8866L2.47934 7.38912C2.17242 7.08221 2 6.66592 2 6.23188V3.63659C2 2.73273 2.73272 2 3.63659 2Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filter icon.f91b24f5c34b251c0f3125dc521492dd.svg";
export { ForwardRef as ReactComponent };